module.exports = __webpack_public_path__ + "static/slack-desktop-efed4756a607ce7071b56e4491a0935f.jpg";